<template>
    <form @submit.prevent="submitPrevent" id="form" name="business_details_form"
          ref="business_details_form" class="content-inner formValidation" v-if="!!merchant?.registration_address">
        <div ref="business_block">
            <div class="row" id="about_business">
                <div class="col-md-12 col-12" v-if="!is_reviewing">
                    <div class="panel-sub-heading headingLarge">
                        <span class="h5 display-6 markedBottom bold">{{ lang('business_details') }}</span>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-12">
                    <!-- About Block for poland -->
                    <div class="row" v-if="searchOnPolandDisabled" ref="block_about_business">
                        <div class="col-12">
                            <div class="panel-sub-heading headingSmall">
                                <span class="markedBottom">{{ lang('about_business') }}</span>
                            </div>
                        </div>
                        <div class="col-12">
                            <np-input :no-wrapper="true" :id="'section'" :name="'section'" :type="'hidden'" model-value="BUSINESS_OUTLET_BANK"></np-input>
                            <np-input
                                :help-text="getTooltipText('application_reg_number')"
                                ref="reg_number"
                                :id="`reg_number`"
                                :name="`reg_number`"
                                :label="regNumberLabel"
                                :minlength=" getRegNoFieldLengthByIso3 ( getIso3FromCountryCode( baseCountryCode ), 'min') "
                                :maxlength=" getRegNoFieldLengthByIso3 ( getIso3FromCountryCode( baseCountryCode ), 'max') "
                                :rules="['alpha_numeric']"
                                :no-wrapper="false"
                                :check_config="false"
                                :required="isRegNumberRequired"
                                v-if="isRegNumberFirst && canShowRegNumber"
                                v-model="merchant.reg_number">
                            </np-input>
                            <np-select2
                                :id="`merchant_ownership_entity_type`"
                                :name="`merchant_ownership_entity_type`"
                                ref="ownership_entity_type"
                                :label="lang('business_type_question')"
                                :placeholder="lang('business_type')"
                                :required="true"
                                :parameters="paramBusinessTypeSB"
                                :no-wrapper="false"
                                @input="setRegNumber"
                                v-model="merchant.ownership_entity_type">
                            </np-select2>
                            <np-input
                                ref="legal_name"
                                :id="`legal_name`"
                                :name="`legal_name`"
                                :help-text="getTooltipText('legal_name_help_text')"
                                :label="lang('legal_name')"
                                :maxlength="255"
                                :rules="['alpha_company']"
                                :no-wrapper="false"
                                v-model="merchant.legal_name">
                            </np-input>
                            <np-input
                                :id="`trade_name`"
                                :name="`trade_name`"
                                :label="lang('trade_name')"
                                :maxlength="50"
                                :help-text="getTooltipText('application_trade_name')"
                                ref="trade_name"
                                :no-wrapper="false"
                                v-model="merchant.trade_name">
                            </np-input>
                            <div id="sub_block_vat" ref="sub_block_vat">
                                <np-radios
                                    ref="int_tax_exempt_flag"
                                    :label="lang('field_int_tax_exempt_flag')"
                                    :id="'int_tax_exempt_flag'"
                                    :name="'int_tax_exempt_flag'"
                                    :required="true"
                                    mode="co-join"
                                    @input="setVatOptions"
                                    :options="parameters.YES_NO_OPTIONS"
                                    v-model="merchant.int_tax_exempt_flag">
                                </np-radios>
                                <np-vat
                                    v-show="merchant.int_tax_exempt_flag === '1'"
                                    :id="`tax_id`"
                                    :name="`tax_id`"
                                    :maxlength="15"
                                    :minlength="1"
                                    :rules="['alpha_numeric']"
                                    :no-wrapper="false"
                                    :required="true"
                                    :label="lang('tax_id')"
                                    :reference="merchantReference"
                                    :country="getIso3FromCountryCode(baseCountryCode)"
                                    :business_type="merchant.ownership_entity_type"
                                    :is_searchable="canUseVatToSearchBusiness"
                                    @search="searchByVatNumber"
                                    ref="tax_id"
                                    :help-text="getTooltipText('tax_id')"
                                    :show-validate-button="canShowVATValidateButton"
                                    v-model="merchant.tax_id">
                                </np-vat>
                                <np-input
                                        :help-text="getTooltipText('application_reg_number')"
                                        ref="reg_number"
                                        :id="`reg_number`"
                                        :name="`reg_number`"
                                        :label="regNumberLabel"
                                        :minlength=" getRegNoFieldLengthByIso3 ( getIso3FromCountryCode( baseCountryCode ), 'min') "
                                        :maxlength=" getRegNoFieldLengthByIso3 ( getIso3FromCountryCode( baseCountryCode ), 'max') "
                                        :rules="['alpha_numeric']"
                                        :no-wrapper="false"
                                        :check_config="false"
                                        :required="isRegNumberRequired"
                                        v-if="!isRegNumberFirst && canShowRegNumber"
                                        v-model="merchant.reg_number">
                                </np-input>
                                <div v-show="merchant.int_tax_exempt_flag === '0'">
                                    <np-radios
                                        ref="vat_applied_flag"
                                        :label="lang('field_vat_applied_flag')"
                                        :id="'vat_applied_flag'"
                                        :name="'vat_applied_flag'"
                                        :required="merchant.int_tax_exempt_flag === '0'"
                                        mode="co-join"
                                        :check_config="false"
                                        @input="setOtherVatTypes"
                                        :options="parameters.VAT_OPTIONS"
                                        v-model="merchant.vat_applied_flag">
                                    </np-radios>
                                    <np-radios v-show="merchant.vat_applied_flag === 'IN_BUSINESS_CONF'"
                                               ref="other_tax_decision"
                                               :label="lang('field_other_vat_type_options')"
                                               :id="'other_tax_decision'"
                                               :name="'other_tax_decision'"
                                               :required="false"
                                               mode="co-join"
                                               :check_config="false"
                                               :options="parameters.OTHER_TAX_NO_TYPE"
                                               v-model="merchant.other_tax_decision">
                                    </np-radios>
                                    <np-input v-show="merchant.vat_applied_flag === 'IN_BUSINESS_CONF'"
                                              ref="other_tax_id"
                                              :id="`other_tax_id`"
                                              :name="`other_tax_id`"
                                              :label="lang('other_tax_number')"
                                              :minlength="getOtherTaxIdFieldLengthByIso3(getIso3FromCountryCode(baseCountryCode), 'min') "
                                              :maxlength="getOtherTaxIdFieldLengthByIso3(getIso3FromCountryCode(baseCountryCode), 'max') "
                                              :required="merchant.other_tax_decision !== ''"
                                              :check_config="false"
                                              :no-wrapper="false"
                                              v-model="merchant.other_tax_id">
                                    </np-input>
                                </div>
                            </div>
                            <np-radios
                                ref="government_owned_entity"
                                :label="lang('government_owned_entity')"
                                :id="'government_owned_entity'"
                                :name="'government_owned_entity'"
                                mode="co-join"
                                :help-text="getTooltipText('government_owned_entity')"
                                :options="parameters.YES_NO_OPTIONS"
                                v-model="merchant.government_owned_entity">
                            </np-radios>
                        </div>
                    </div>
                    <!-- About Block for other alliances -->
                    <div class="row" v-else ref="block_about_business">
                        <div class="col-12">
                            <div class="panel-sub-heading headingSmall">
                                <span class="markedBottom">{{ lang('about_business') }}</span>
                            </div>
                        </div>
                        <div class="col-12">
                            <np-input :no-wrapper="true" :id="'section'" :name="'section'" :type="'hidden'" model-value="BUSINESS_OUTLET_BANK"></np-input>
                            <np-input
                                :help-text="getTooltipText('application_reg_number')"
                                ref="reg_number"
                                :id="`reg_number`"
                                :name="`reg_number`"
                                :label="regNumberLabel"
                                :minlength=" getRegNoFieldLengthByIso3 ( getIso3FromCountryCode( baseCountryCode ), 'min') "
                                :maxlength=" getRegNoFieldLengthByIso3 ( getIso3FromCountryCode( baseCountryCode ), 'max') "
                                :rules=registerNumberRule
                                :no-wrapper="false"
                                :check_config="false"
                                :required="isApplicationRegNumberRequired"
                                @addon-click="searchByRegNumber"
                                v-if="isRegNumberFirst && canShowRegNumber"
                                v-model="merchant.reg_number">
                                <template #addon>
                                <span class="fa fa-search"></span>
                                </template>
                            </np-input>
                            <np-select2
                                :id="`merchant_ownership_entity_type`"
                                :name="`merchant_ownership_entity_type`"
                                ref="ownership_entity_type"
                                :label="lang('business_type_question')"
                                :placeholder="lang('business_type')"
                                :required="true"
                                :parameters="paramBusinessTypeSB"
                                :no-wrapper="false"
                                @input="setRegNumber"
                                v-model="merchant.ownership_entity_type">
                            </np-select2>
                            <np-input
                                ref="legal_name"
                                :id="`legal_name`"
                                :name="`legal_name`"
                                :help-text="getTooltipText('legal_name_help_text')"
                                :label="lang('legal_name')"
                                :rules="['alpha_company']"
                                :maxlength="255"
                                :no-wrapper="false"
                                @addon-click="searchByLegalName"
                                v-if="allowLegalNameSearch"
                                v-model="merchant.legal_name">
                                <template #addon>
                                <span class="fa fa-search"></span>
                                </template>
                            </np-input>
                            <np-input
                                ref="legal_name"
                                :id="`legal_name`"
                                :name="`legal_name`"
                                :help-text="getTooltipText('legal_name_help_text')"
                                :label="lang('legal_name')"
                                :maxlength="255"
                                :rules="['alpha_company']"
                                :no-wrapper="false"
                                v-else
                                v-model="merchant.legal_name">
                            </np-input>
                            <np-input
                                :help-text="getTooltipText('application_reg_number')"
                                ref="reg_number"
                                :id="`reg_number`"
                                :name="`reg_number`"
                                :label="regNumberLabel"
                                :minlength=" getRegNoFieldLengthByIso3 ( getIso3FromCountryCode( baseCountryCode ), 'min') "
                                :maxlength=" getRegNoFieldLengthByIso3 ( getIso3FromCountryCode( baseCountryCode ), 'max') "
                                :rules=registerNumberRule
                                :no-wrapper="false"
                                :check_config="false"
                                :required="isApplicationRegNumberRequired"
                                @addon-click="searchByRegNumber"
                                v-if="!isRegNumberFirst && canShowRegNumber"
                                v-model="merchant.reg_number">
                                <template #addon>
                                <span class="fa fa-search"></span>
                                </template>
                            </np-input>
                            <np-input
                                :id="`trade_name`"
                                :name="`trade_name`"
                                :label="lang('trade_name')"
                                :maxlength="getTradeNameFieldLengthByIso3( getIso3FromCountryCode( baseCountryCode ), 'max') "
                                :rules="['alpha_company']"
                                :help-text="getTooltipText('application_trade_name')"
                                ref="trade_name"
                                :no-wrapper="false"
                                v-model="merchant.trade_name">
                            </np-input>
                            <div id="sub_block_vat" ref="sub_block_vat">
                                <np-radios
                                    v-show="!checkAppDefaultFieldIsReadOnly('int_tax_exempt_flag')"
                                    ref="int_tax_exempt_flag"
                                    :label="lang('field_int_tax_exempt_flag')"
                                    :id="'int_tax_exempt_flag'"
                                    :name="'int_tax_exempt_flag'"
                                    :required="true"
                                    mode="co-join"
                                    @input="setVatOptions"
                                    :options="parameters.YES_NO_OPTIONS"
                                    v-model="merchant.int_tax_exempt_flag">
                                </np-radios>
                                <np-vat
                                    v-show="merchant.int_tax_exempt_flag === '1'"
                                    :id="`tax_id`"
                                    :name="`tax_id`"
                                    :minlength=" getVatFieldLengthByIso3 ( getIso3FromCountryCode( baseCountryCode ), 'min') "
                                    :maxlength=" getVatFieldLengthByIso3 ( getIso3FromCountryCode( baseCountryCode ), 'max') "
                                    :rules="getVATValidationRules"
                                    :no-wrapper="false"
                                    :required="true"
                                    :label="getVATLabelFromCountryCode(allianceCountry)"
                                    :reference="merchantReference"
                                    :country="getIso3FromCountryCode(baseCountryCode)"
                                    :business_type="merchant.ownership_entity_type"
                                    :is_searchable="canUseVatToSearchBusiness"
                                    @search="searchByVatNumber"
                                    ref="tax_id"
                                    :help-text="getTooltipText('tax_id')"
                                    :show-validate-button="canShowVATValidateButton"
                                    v-model="merchant.tax_id">
                                </np-vat>
                                <div v-show="merchant.int_tax_exempt_flag === '0'">
                                    <np-radios
                                        ref="vat_applied_flag"
                                        :label="lang('field_vat_applied_flag')"
                                        :id="'vat_applied_flag'"
                                        :name="'vat_applied_flag'"
                                        :required="merchant.int_tax_exempt_flag === '0'"
                                        mode="co-join"
                                        :check_config="false"
                                        @input="setOtherVatTypes"
                                        :options="parameters.VAT_OPTIONS"
                                        v-model="merchant.vat_applied_flag">
                                    </np-radios>
                                    <np-radios v-show="merchant.vat_applied_flag === 'IN_BUSINESS_CONF'"
                                               ref="other_tax_decision"
                                               :label="lang('field_other_vat_type_options')"
                                               :id="'other_tax_decision'"
                                               :name="'other_tax_decision'"
                                               :required="false"
                                               mode="co-join"
                                               :check_config="false"
                                               :options="parameters.OTHER_TAX_NO_TYPE"
                                               v-model="merchant.other_tax_decision">
                                    </np-radios>
                                    <np-input v-show="merchant.vat_applied_flag === 'IN_BUSINESS_CONF'"
                                              ref="other_tax_id"
                                              :id="`other_tax_id`"
                                              :name="`other_tax_id`"
                                              :label="lang('other_tax_number')"
                                              :minlength="getOtherTaxIdFieldLengthByIso3(getIso3FromCountryCode(baseCountryCode), 'min') "
                                              :maxlength="getOtherTaxIdFieldLengthByIso3(getIso3FromCountryCode(baseCountryCode), 'max') "
                                              :required="merchant.other_tax_decision !== ''"
                                              :check_config="false"
                                              :no-wrapper="false"
                                              v-model="merchant.other_tax_id">
                                    </np-input>
                                </div>
                            </div>
                            <np-radios
                                ref="government_owned_entity"
                                :label="lang('government_owned_entity')"
                                :id="'government_owned_entity'"
                                :name="'government_owned_entity'"
                                mode="co-join"
                                :help-text="getTooltipText('government_owned_entity')"
                                :options="parameters.YES_NO_OPTIONS"
                                v-model="merchant.government_owned_entity">
                            </np-radios>
                        </div>
                    </div>


                    <div class="row" ref="block_business_detail">
                        <div class="col-lg-6 col-md-12 col-12">
                            <np-responsive>
                                <template #label>
                                <span>
                                    {{dateOfIncorporationLabel}}
                                    <span
                                        v-if="!!lang('date_incorporation_tooltip')"
                                        data-bs-placement="right"
                                        data-container="body"
                                        data-bs-toggle="popover"
                                        :title="dateOfIncorporationLabel"
                                        :data-popover-content="getTooltipText('application_date_of_incorporation')"
                                        class="helpBtn addPopover helpHeader">
                                        <i tabindex="-1" class="fa fa-info-circle"></i>
                                    </span>
                                </span>
                                </template>
                                <template #input>
                                <div class="form-group input-group">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <i class="fa fa-calendar"></i>
                                        </div>
                                    </div>
                                    <np-date-picker ref="date_of_incorporation"
                                                    :help-text="getTooltipText('application_date_of_incorporation')"
                                                    :label="dateOfIncorporationLabel"
                                                    :id="`date_incorporated`"
                                                    :name="`date_incorporated`"
                                                    :placeholder="dateOfIncorporationLabel"
                                                    class="form-control"
                                                    :end-date="`-0d`"
                                                    v-model="merchant.date_incorporated">
                                    </np-date-picker>
                                </div>
                                </template>
                            </np-responsive>
                        </div>
                        <div class="col-lg-6 col-md-12 col-12">
                            <np-select2
                                :id="`funding_currency`"
                                :name="`funding_currency`"
                                :label="lang('settlement_currency')"
                                :placeholder="lang('settlement_currency')"
                                ref="funding_currency"
                                :required="false"
                                :parameters="parameters.FUNDING_CURRENCIES"
                                :no-wrapper="false"
                                v-model="merchant.client_group_number">
                            </np-select2>
                        </div>
                    </div>
                    <div ref="block_intermediary_owners" v-if="canHaveIntermediaryByIso3(getIso3FromCountryCode(baseCountryCode), merchant.ownership_entity_type)">
                        <div class="row">
                            <div class="col-md-12">
                                <np-radios
                                    v-if="canHaveIntermediaryByIso3(getIso3FromCountryCode(baseCountryCode), merchant.ownership_entity_type)"
                                    ref="has_intermediary_owner"
                                    :label="lang('field_has_intermediary_owner')"
                                    :id="'has_intermediary_owner'"
                                    :name="'has_intermediary_owner'"
                                    :no-wrapper="false"
                                    mode="co-join"
                                    @input="toggleIntermediaryOwners"
                                    :options="parameters.YES_NO_OPTIONS"
                                    v-model="merchant.has_intermediary_owner">
                                </np-radios>
                                <!--                                                        <input-->
                                <!--                                                                  :id="'remaining_ownership'"-->
                                <!--                                                                  :name="'remaining_ownership'"-->
                                <!--                                                                  type="hidden"-->
                                <!--                                                                  :value="ownershipBalance">-->
                            </div>
                        </div>

                        <div class="row" ref="sub_block_intermediary_owners"  v-show="merchant.has_intermediary_owner === '1'">
                            <div class="col-md-12">
                                <div class="panel-sub-heading headingSmall ">
                                    <span class="markedBottom">{{ lang('intermediary_owners') }}</span>
                                    <button class="btn btn-xs btn-default float-right float-end btn-with-label addTooltip excludeLink"
                                            :data-tooltip-text="lang('add_more_intermediary_owners')" type="button"
                                            @click="addMoreIntermediaryOwners" data-original-title=""
                                            title="">
                                        <span class="btn-label"><i class="fa fa-plus"></i></span>
                                        {{lang('add_more_intermediary_owners')}}
                                    </button>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <table class="table table-hover">
                                            <colgroup>
                                                <col class="col-md-004p">
                                                <col class="col-md-058p">
                                                <col class="col-md-030p">
                                                <col class="col-md-008p">
                                            </colgroup>
                                            <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col" v-text="lang('business_name')"></th>
                                                <th scope="col" v-text="lang('ownership_percentage')"></th>
                                                <th scope="col"> </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(intermediary_owner, oindex) in merchant.intermediary_owners">
                                                <td scope="row">{{oindex+1}}</td>
                                                <td>
                                                    <np-input
                                                        :id="`business_name_${oindex}`"
                                                        :name="`business_name[${oindex}]`"
                                                        :label="lang('business_name')"
                                                        :rules="['alpha_company']"
                                                        :maxlength="40"
                                                        :no-wrapper="true"
                                                        ref="business_name"
                                                        :required="true"
                                                        v-model="intermediary_owner.business_name">
                                                    </np-input>
                                                </td>
                                                <td>
                                                    <np-input
                                                        :id="`ownership_percentage_${oindex}`"
                                                        :name="`ownership_percentage[${oindex}]`"
                                                        :label="lang('ownership_percentage')"
                                                        :rules="['numeric', 'together_less_than_equal_n_percent_group', {'expected_total' : `${ownershipBalance}` }, {'percent_group':'intermediary_ownership'} ]"
                                                        :maxlength="3"
                                                        ref="ownership_percentage"
                                                        :required="true"
                                                        :no-wrapper="true"
                                                        :addon-on-left="false"
                                                        v-model="intermediary_owner.ownership_percentage"> <!-- @input="logIntermediaryPercentage(intermediary_owner.ownership_percentage)" -->
                                                        <template #addon>
                                                        <span>%</span>
                                                        </template>
                                                    </np-input>
                                                </td>
                                                <td>
                                                    <a v-show="oindex > 0" @click="removeIntermediaryOwner(oindex)" class="float-right float-end btn btn-sm btn-warning"><i class="fa fa-trash"></i></a>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>


                                    </div>
                                </div>

                            </div>
                        </div>
                        <np-radios
                            :label="lang('has_more_intermediary_owners')"
                            :id="'additional_intermediary_owners'"
                            :name="'additional_intermediary_owners'"
                            ref="additional_intermediary_owners"
                            mode="co-join"
                            v-show="merchant.has_intermediary_owner === '1'"
                            :options="parameters.YES_NO_OPTIONS"
                            v-model="merchant.additional_intermediary_owners">
                        </np-radios>
                    </div>
                    <div class="row" ref="block_application_options">
                    <div class="col-12">
                      <div class="panel-sub-heading headingSmall">
                        <span class="markedBottom">{{ lang('application_options') }}</span>
                      </div>
                    </div>
                    <div class="col-12">
                        <np-checkbox
                            :label="lang('marketing_opt_in')"
                            :id="'marketing_opt_in'"
                            :name="'marketing_opt_in'"
                            ref="marketing_opt_in"
                            :description="lang('marketing_opt_in_tooltip')"
                            :required="true"
                            :full-label="true"
                            :check_config="true"
                            :help-text="getTooltipText('marketing_opt_in_tooltip')"
                            :help-text-position="'label'"
                            v-model="merchant.marketing_opt_in">
                        </np-checkbox>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-12"  v-if="!!merchant?.registration_address">
                    <div class="row" ref="block_registered_address">
                        <div class="col-12">
                          <div class="panel-sub-heading headingSmall">
                            <span class="markedBottom">{{ lang('business_registered_address') }}</span>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-12">
                            <np-input
                              :id="`house_number`"
                              :name="`house_number`"
                              ref="house_number"
                              :label="lang('building_number')"
                              :rules="['alpha_numeric_slash']"
                              :maxlength="20"
                              :no-wrapper="false"
                              :required="false"
                              v-model="merchant.registration_address.house_number">
                            </np-input>
                        </div>
                        <div class="col-lg-8 col-md-12">
                          <np-postcode-search
                              :label="lang('post_code')"
                              :id="`zip_code`"
                              :name="`zip_code`"
                              ref="zip_code"
                              :required="true"
                              :rules="getPostCodeRules()"
                              :minlength="getPostCodeFieldLengthByIso3(getIso3FromCountryCode(baseCountryCode), 'min')"
                              :maxlength="getPostCodeFieldLengthByIso3(getIso3FromCountryCode(baseCountryCode), 'max')"
                              :reference="merchantReference"
                              :iso3=" getIso3FromCountryCode( baseCountryCode ) "
                              v-model="merchant.registration_address.zip_code"
                              @input="changedPostcode(merchant.registration_address)"
                              @empty-address="allowManualEdit"
                              @address-selected="updateCompanyAddress($event, merchant.registration_address)"
                          ></np-postcode-search>
                        </div>
                        <div class="col-md-12 mt-3" v-if="merchant.registration_address.zip_code === '' && !edit_address
                            && merchant.registration_address.street_line_1 === ''">
                            <div class="card card--address--reminder">
                                <div class="card-body">
                                    <span class="card-text">{{lang('please_search_postcode_for_details')}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 mt-3" v-if="!edit_address">
                            <div class="" v-if="merchant.registration_address.street_line_1 !== ''">
                                <div class="card card--address">
                                    <div class="card-body">
                                            <span class="card-text"
                                                  v-html="formatAddress(merchant.registration_address, true)"></span>
                                    </div>
                                </div>
                            </div>
                            <button @click="editAddress" class="btn btn-primary float-right float-end" type="button">
                                {{ lang('enter_address_manually') }}
                            </button>
                        </div>
                        <div class="col-md-12" v-show="edit_address">
                          <np-input
                              ref="house_name"
                              :id="`house_name`"
                              :name="`house_name`"
                              :label="lang('building_name')"
                              :no-wrapper="false"
                              :required="false"
                              :maxlength="getHouseNameFieldLength('max')"
                              v-model="merchant.registration_address.house_name">
                          </np-input>
                          <np-input
                              ref="street_line_1"
                              :id="`street_line_1`"
                              :name="`street_line_1`"
                              :label="lang('field_street')"
                              :rules="['alpha_space_dot']"
                              :maxlength="getStreetNameFieldLength('max')"
                              :no-wrapper="false"
                              v-model="merchant.registration_address.street_line_1">
                          </np-input>
                          <np-input
                              ref="city"
                              :id="`city`"
                              :name="`city`"
                              :label="lang('field_town_city')"
                              :rules="['valid_city_town']"
                              :no-wrapper="false"
                              :maxlength="getCityFieldLength('max')"
                              v-model="merchant.registration_address.city">
                          </np-input>
                          <div v-if="merchant.registration_address.country_code === '840'">
                            <np-select2
                                ref="county_code"
                                :id="`county_code`"
                                :name="`county_code`"
                                :label="lang('state')"
                                :placeholder="lang('state')"
                                :parameters="parameters.STATES_PARAM"
                                :no-wrapper="false"
                                v-country-dependent="[merchant.registration_address.country_code, 'county_code']"
                                v-model="merchant.registration_address.county_code">
                            </np-select2>
                          </div>
                          <div v-else>
                            <np-input
                                ref="county_code"
                                :id="`county_code`"
                                :name="`county_code`"
                                :label="lang('field_county_state')"
                                :rules="['alpha_space_dots']"
                                :no-wrapper="false"
                                v-country-dependent="[merchant.registration_address.country_code, 'county_code']"
                                v-model="merchant.registration_address.county_code">
                            </np-input>
                          </div>
                          <np-select2
                              ref="country_code"
                              :id="`country_code`"
                              :name="`country_code`"
                              :label="lang('country')"
                              :placeholder="lang('country')"
                              :mode="`country`"
                              :parameters="country_code_params"
                              :no-wrapper="false"
                              v-model="merchant.registration_address.country_code">
                          </np-select2>
                        </div>
                    </div>
                    <div class="row" ref="block_finder_registered_address">
                        <div class="col-12">
                            <div class="panel-sub-heading headingSmall">
                                <span class="markedBottom">{{ lang('business_registered_address') }}</span>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <np-postcode-search
                                    :id="`address_finder`"
                                    :name="`address_finder`"
                                    ref="address_finder"
                                    :label="lang('address_or_postcode_search')"
                                    :required="false"
                                    :maxlength="50"
                                    :rules="getPostCodeRules(['alpha_address_finder'])"
                                    :reference="merchantReference"
                                    :postcode_only="false"
                                    :iso3="getIso3FromCountryCode(baseCountryCode)"
                                    v-model="merchant.registration_address.address_finder"
                                    @input="changedAddressFinderSearch(merchant.registration_address)"
                                    @empty-address="allowManualEdit"
                                    @address-selected="updateCompanyAddress($event, merchant.registration_address, true)"
                            ></np-postcode-search>
                        </div>
                        <div class="col-md-12 mt-3" v-if="merchant.registration_address.address_finder === '' &&
                         !edit_address && merchant.registration_address.street_line_1 === ''">
                            <div class="card card--address--reminder">
                                <div class="card-body">
                                    <span class="card-text">{{lang('please_search_postcode_or_address_for_details')}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 mt-3" v-if="!edit_address">
                            <div class="" v-if="merchant.registration_address.street_line_1 !== ''">
                                <div class="card card--address">
                                    <div class="card-body">
                                            <span class="card-text"
                                                  v-html="formatAddress(merchant.registration_address, true)"></span>
                                    </div>
                                </div>
                            </div>
                            <button type="button" @click="editAddress" class="btn btn-primary float-right float-end">
                                {{ lang('enter_address_manually') }}
                            </button>
                        </div>
                        <div class="col-md-12" v-show="edit_address">
                            <div class="row" v-for="address_row in getBusinessAddressFinderStructureByIso3(getIso3FromCountryCode(allianceCountry))">
                                <template v-for="address_field in address_row">
                                    <div :class="address_field[1]" v-if="address_field[0] === 'finder_house_number'">
                                        <np-input
                                                :id="`finder_house_number`"
                                                :name="`house_number`"
                                                :label="getHouseNumberLabelFromCountryCode(allianceCountry)"
                                                :rules="['alpha_numeric_slash']"
                                                :maxlength="20"
                                                :no-wrapper="false"
                                                :required="false"
                                                ref="finder_house_number"
                                                v-model="merchant.registration_address.house_number">
                                        </np-input>
                                    </div>
                                    <div :class="address_field[1]" v-if="address_field[0] === 'finder_house_name'">
                                        <np-input
                                                :id="`finder_house_name`"
                                                :name="`house_name`"
                                                :label="getHouseNameLabelFromCountryCode(allianceCountry)"
                                                :no-wrapper="false"
                                                :required="false"
                                                ref="finder_house_name"
                                                :maxlength="getHouseNameFieldLength('max')"
                                                v-model="merchant.registration_address.house_name">
                                        </np-input>
                                    </div>
                                    <div :class="address_field[1]" v-if="address_field[0] === 'finder_street_line_1'">
                                        <np-input
                                                :id="`finder_street_line_1`"
                                                :name="`street_line_1`"
                                                :label="getStreetLabelFromCountryCode(allianceCountry)"
                                                :rules="['alpha_space_dot']"
                                                :maxlength="getStreetNameFieldLength('max')"
                                                :no-wrapper="false"
                                                ref="finder_street_line_1"
                                                v-model="merchant.registration_address.street_line_1">
                                        </np-input>
                                    </div>
                                    <div :class="address_field[1]" v-if="address_field[0] === 'finder_city'">
                                        <np-input
                                                :id="`finder_city`"
                                                :name="`city`"
                                                :label="getCityLabelFromCountryCode(allianceCountry)"
                                                :rules="['valid_city_town']"
                                                :no-wrapper="false"
                                                ref="finder_city"
                                                :maxlength="getCityFieldLength('max')"
                                                v-model="merchant.registration_address.city">
                                        </np-input>
                                    </div>
                                    <div :class="address_field[1]" v-if="address_field[0] === 'finder_county_code'" ref="finder_county_code">
                                        <np-select2
                                                v-if="merchant.registration_address.country_code === '840'"
                                                :id="`finder_county_code`"
                                                :name="`county_code`"
                                                :label="lang('state')"
                                                :placeholder="lang('state')"
                                                :parameters="parameters.STATES_PARAM"
                                                :no-wrapper="false"
                                                v-country-dependent="[merchant.registration_address.country_code, 'county_code']"
                                                v-model="merchant.registration_address.county_code">
                                        </np-select2>
                                        <np-input
                                                v-else
                                                :id="`finder_county_code`"
                                                :name="`county_code`"
                                                :label="lang('field_county_state')"
                                                :rules="['alpha_space_dots']"
                                                :no-wrapper="false"
                                                v-country-dependent="[merchant.registration_address.country_code, 'county_code']"
                                                v-model="merchant.registration_address.county_code">
                                        </np-input>
                                    </div>
                                    <div :class="address_field[1]" v-if="address_field[0] === 'finder_country_code'">
                                        <np-select2
                                                :id="`finder_country_code`"
                                                :name="`country_code`"
                                                :label="lang('country')"
                                                :placeholder="lang('country')"
                                                :mode="`country`"
                                                :parameters="country_code_params"
                                                :no-wrapper="false"
                                                ref="finder_country_code"
                                                @input="onCountryCodeChange($event,'finder_zip_code')"
                                                v-model="merchant.registration_address.country_code">
                                        </np-select2>
                                    </div>
                                    <div :class="address_field[1]" v-if="address_field[0] === 'finder_zip_code'">
                                        <np-input
                                                :id="`finder_zip_code`"
                                                :name="`zip_code`"
                                                :label="lang('post_code')"
                                                :required="true"
                                                ref="finder_zip_code"
                                                :rules="getPostCodeRules([{country_postcode_validator : merchant.registration_address.country_code}])"
                                                :no-wrapper="false"
                                                :minlength="getPostCodeFieldLengthByIso3(getMerchantCountryCode(merchant.registration_address.country_code), 'min')"
                                                :maxlength="getPostCodeFieldLengthByIso3(getMerchantCountryCode(merchant.registration_address.country_code), 'max')"
                                                v-model="merchant.registration_address.zip_code">
                                        </np-input>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>

                    <div class="row" id="bank_detail_form" ref="block_bank_accounts">
                    <template  v-for="(bank, bank_index) in outlet.banks">
                      <div class="col-12" v-if="bankTypeAllowedForTenant(bank.account_type)">
                        <div class="panel-sub-heading headingSmall">
                          <span class="h5 display-6 markedBottom bold">
                            <span>{{ lang('bank_details') + (!!bank.account_type ? ` (${lang('for')} ${getBankType(bank.account_type)})` : '')  }}</span>

                          <button type="button" class="btn btn-warning btn-xs btn-with-label float-right float-end" v-if="bank_index > 0 && !isFirstDepositBank(bank, bank_index) "  @click="removeBank(bank_index)">
                            <span class="btn-label"><i class="fa fa-trash"></i></span><span>{{lang('remove_account')}}</span>
                          </button>
                          </span>

                        </div>
                      </div>

                      <div class="col-12" v-if="bankTypeAllowedForTenant(bank.account_type)">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <np-select2
                                ref="bank_account_type"
                                :id="`bank_account_type_${bank_index}`"
                                :name="`bank_account_type[${bank_index}]`"
                                :label="lang('account_type')"
                                :placeholder="lang('account_type')"
                                :parameters="residualBankTypeParam[bank_index]"
                                :no-wrapper="false"
                                :disabled="isFirstDepositBank(bank, bank_index)"
                                v-model="bank.account_type">
                            </np-select2>
                          </div>
                        </div>
                        <np-input ref="account_holder_name"
                                  :id="`bank_account_holder_name_${bank_index}`"
                                  :name="`bank_account_holder_name[${bank_index}]`"
                                  :label="lang('account_holder_name')"
                                  :required="true"
                                  :help-text="getTooltipText('bank_account_name_help_text')"
                                  v-model="bank.account_holder_name">
                        </np-input>
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <np-input ref="bank_sort_code"
                                      :id="`bank_sort_code_${bank_index}`"
                                      :name="`bank_sort_code[${bank_index}]`"
                                      :label="lang('sort_code')"
                                      :rules="['is_natural']"
                                      :required="true"
                                      :minlength="getSortCodeFieldLengthByIso3(getMerchantCountryCode(merchant.registration_address.country_code), 'min')"
                                      :maxlength="getSortCodeFieldLengthByIso3(getMerchantCountryCode(merchant.registration_address.country_code), 'max')"
                                      @blur="() => {$refs.hasOwnProperty('debit_bank_account_number') && $refs.debit_bank_account_number.validateBank(bank.bank_account_number)}"
                                      @input="updateBankIsValidStatus(bank)"
                                      v-model="bank.bank_sort_code">
                            </np-input>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <np-bank
                                ref="bank_account_number"
                                :id="`bank_account_number_${bank_index}`"
                                :name="`bank_account_number[${bank_index}]`"
                                :label="lang('account_number')"
                                :required="true"
                                :minlength="getAccountNumbereFieldLengthByIso3(getIso3FromCountryCode(baseCountryCode), 'min')"
                                :maxlength="getAccountNumbereFieldLengthByIso3(getIso3FromCountryCode(baseCountryCode), 'max')"
                                :reference="{'application': merchant.application_reference}"
                                :show-validate-button="false"
                                :country="getIso3FromCountryCode(baseCountryCode)"
                                :disableAutocomplete="true"
                                @input="updateBankIsValidStatus(bank)"
                                @bank-validated="bankIsValid(bank, $event, getIso3FromCountryCode(baseCountryCode))"
                                :sort-code="bank.bank_sort_code"
                                v-model="bank.bank_account_number">
                            </np-bank>
                          </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-12">
                                <np-input
                                        ref="swift"
                                        :id="`swift_${bank_index}`"
                                        :name="`swift[${bank_index}]`"
                                        :label="lang('bank_swift')"
                                        :rules="['bic_length','alpha_numeric_bic']"
                                        :required="true"
                                        @blur="appendXXX(bank)"
                                        :maxlength="getBICFieldLengthByIso3(getIso3FromCountryCode(baseCountryCode), 'max')"
                                        :minlength=" getBICFieldLengthByIso3( getIso3FromCountryCode(baseCountryCode), 'min' ) "
                                        v-model="bank.swift">
                                </np-input>
                            </div>
                            <div class="col-12" :class="{'col-lg-12 col-md-12': !bicIsOn, 'col-lg-8 col-md-8': bicIsOn }">
                                <np-bank ref="iban"
                                         :id="`iban_${bank_index}`"
                                         :name="`iban[${bank_index}]`"
                                         :label="lang('iban')"
                                         :rules="['alpha_numeric_alpha']"
                                         :check_config="ibanCheckConfiguration(bank)"
                                         :required="ibanRequired(bank)"
                                         :help-text="getTooltipText('iban_help_text')"
                                         :is-iban="true"
                                         :country="getIso3FromCountryCode(baseCountryCode)"
                                         :reference="{'application': merchant.application_reference}"
                                         :show-validate-button="ibanShowValidateButton(bank)"
                                         @blur="() => {$refs.hasOwnProperty('debit_iban') && $refs.debit_iban.validateBank(bank.iban)}"
                                         @input="updateBankIsValidIbanStatus(bank, $event)"
                                         @bank-validated="bankIsValid(bank, $event)"
                                         v-model="bank.iban">
                                </np-bank>
                            </div>
                        </div>
                        <np-input v-if="useGiroCard()"
                                  ref="bank_creditor_id"
                                  :id="`bank_creditor_id_${bank_index}`"
                                  :name="`bank_creditor_id[${bank_index}]`"
                                  :label="lang('field_bank_creditor_id')"
                                  :minlength="24"
                                  :maxlength="24"
                                  :check_config="false"
                                  :required="true"
                                  :rules="['numeric']"
                                  v-model="bank.bank_creditor_id">
                        </np-input>
                        <np-input ref="bank_name"
                                  :id="`bank_name_${bank_index}`"
                                  :name="`bank_name[${bank_index}]`"
                                  :label="lang('field_bank_name')"
                                  :required="true"
                                  maxlength="200"
                                  v-model="bank.bank_name">
                        </np-input>
                          <div class="col-md-12" v-if="!!bank.show_disabled_faster_payments_message">
                              <np-notice notice-class="alert-warning" :dismissable="false"
                                         :notice="lang('faster_payments_not_allowed_for_bank')"></np-notice>
                          </div>
                        <np-radios
                            :id="`settlement_method_${bank_index}`"
                            :name="`settlement_method[${bank_index}]`"
                            :is-full="true"
                            ref="settlement_method"
                            mode="co-join"
                            :label="lang('settlement_method')"
                            :options="parameters.SETTLEMENT_METHODS"
                            @input="setSettlementMethodForAllBanks"
                            v-model="bank.settlement_method">
                        </np-radios>
<!--                        <np-radios-->
<!--                            :id="`faster_payments_${bank_index}`"-->
<!--                            :name="`faster_payments[${bank_index}`"-->
<!--                            :is-full="true"-->
<!--                            ref="faster_payments"-->
<!--                            :label="lang('faster_payments')"-->
<!--                            mode="co-join"-->
<!--                            :disabled="bank.disabled_faster_payments === '1'"-->
<!--                            :options="parameters.YES_NO_OPTIONS"-->
<!--                            v-model="bank.faster_payments">-->
<!--                        </np-radios>-->
                      </div>
                    </template>
                    <div class="col-12">
                      <button type="button" class="btn btn-default btn-with-label float-right float-end" v-if="allowMoreBanks && MAX_NUMBER_OF_BANKS_ALLOWED > outlet.banks.length" @click="addBank">
                        <span class="btn-label"><i class="fa fa-plus"></i></span>{{lang('additional_bank_account')}}
                      </button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <np-company-search v-if="!!merchant?.registration_address" ref="company-search"
                           :company-name="merchant.legal_name"
                           :registration-number="merchant.reg_number"
                           :vat-number="merchant.tax_id"
                           :business-type="canUseVatToSearchBusiness ? merchant.ownership_entity_type : null"
                           :search_transparent_data="canUseVatToSearchBusiness"
                           :search_bisnode_data="isBisNodeSearch"
                           :country_code="merchant.registration_address.country_code"
                           :reference="merchantReference"
                           :country=" getMerchantCountryCode(merchant.registration_address.country_code) "
                           :show_reg_num_options="isGermanAlliance"
                           @data="processCompanySearchData">
        </np-company-search>
        <div class="row mt-4" style="border-top: 1px solid #b2c6d0"  v-if="is_reviewing && isOpenApplication">
            <div class="col-12">
                <div class="my-3">
                    <a class="btn btn-default" @click="saveBusinessDetails"> {{lang('save')}}</a>
                </div>
            </div>
        </div>
        <div class="row mt-4" v-else-if="!is_reviewing" style="border-top: 1px solid #b2c6d0">
            <div class="col-12">
                <div class="my-3">
                    <button type="button" class="btn btn-danger me-1" @click="goBack"> {{lang('go_back')}}</button>
                    <button type="button" class="btn btn-default me-1" @click="doContinue"> {{lang('continue')}}</button>
                </div>
            </div>
        </div>
    </form>
    <np-skeleton v-else :type="'full_view'"></np-skeleton>

</template>

<script>
    import utilMixin from "../../../utils/mixins";
    import applicationMixin from "../../../utils/application-mixin";
    import {
        NPBank,
        NPCheckBox,
        NPCompanySearch,
        NPDatePicker,
        NPInput,
        NPModal,
        NPNotice,
        NPPhone,
        NPPostcodeSearch,
        NPRadios,
        NPResponsive,
        NPSelect2,
        NPSkeleton,
        NPTextArea,
        NPVat
    } from "netpify/components";
    import {BankDetails} from "../../../entities";
    import {defaultCountry} from "../../../entities/default";

    import * as types from "../../../stores/constants";
    import EventBus from "../../../utils/event_bus";
    import {IntermediaryOwner} from "../../../entities";
    import useModuleStore from "../../../stores";

    export default {
        name: "businessDetails",
        mixins:[utilMixin, applicationMixin],
        components: {
            'np-bank': NPBank,
            'np-modal': NPModal,
            'np-textarea': NPTextArea,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-checkbox': NPCheckBox,
            'np-date-picker': NPDatePicker,
            'np-select2': NPSelect2,
            'np-company-search': NPCompanySearch,
            'np-postcode-search': NPPostcodeSearch,
            'np-responsive': NPResponsive,
            'np-vat': NPVat,
            'np-phone': NPPhone,
            'np-skeleton': NPSkeleton,
            'np-notice': NPNotice
        },
        props: {
            is_reviewing: {
                default: false,
                type: Boolean,
            }
        },
        data() {
            return {
                old_valid_iban_value: {
                    DEBIT: null,
                    CHARGEBACK: null,
                    CREDIT: null,
                },
                provide_principal_details: '',
                principal_details_param: [
                    {
                        label: this.lang('can_provide_principal_details'),
                        value: '0'
                    },
                    {
                        label: this.lang('can_invite_principal_for_details'),
                        value: '1'
                    },
                ],
                bankTypes: [
                    {
                        label: this.lang('use_business_bank_account'),
                        value: 'BUSINESS',
                    },
                    {
                        label: this.lang('use_store_bank_account'),
                        value: 'OUTLET',
                    },
                ],
                bank_account_types_param: [
                    {'id': 'DEPOSIT', 'text': this.lang('savings')},
                    {'id': 'BILLING', 'text': this.lang('checking')}
                ],
                status: '',
                page_config_template: 'SelfBusinessInformation',
                abortRouteLeave: false,
                MAX_NUMBER_OF_BANKS_ALLOWED: 3,
                app_default_param: {
                    COUNTRY_CODE: "country_code",
                    ENTITY_BLOCK_BUSINESS: "BUSINESS",
                    ENTITY_BLOCK_ALL_OUTLET: "ALL_OUTLET",
                    ENTITY_BLOCK_MAIN_OUTLET: "MAIN_OUTLET",
                },
                country_code_params: [],
                deposit_bank_faster_payments: '',
                business_address_finder_structure: {
                    'SWE': [
                        [['finder_street_line_1', 'col-lg-12 col-md-12']],
                        [['finder_house_number', 'col-lg-4 col-md-4'], ['finder_house_name', 'col-lg-8 col-md-8']],
                        [['finder_zip_code', 'col-lg-12 col-md-12']],
                        [['finder_city', 'col-lg-12 col-md-12']],
                        [['finder_county_code', 'col-lg-12 col-md-12']],
                        [['finder_country_code', 'col-lg-12 col-md-12']],
                    ],
                    'NOR': [
                        [['finder_street_line_1', 'col-lg-12 col-md-12']],
                        [['finder_house_number', 'col-lg-4 col-md-4'], ['finder_house_name', 'col-lg-8 col-md-8']],
                        [['finder_zip_code', 'col-lg-12 col-md-12']],
                        [['finder_city', 'col-lg-12 col-md-12']],
                        [['finder_county_code', 'col-lg-12 col-md-12']],
                        [['finder_country_code', 'col-lg-12 col-md-12']],
                    ],
                    'DEU': [
                        [['finder_street_line_1', 'col-lg-8 col-md-8'], ['finder_house_number', 'col-lg-4 col-md-4']],
                        [['finder_zip_code', 'col-lg-8 col-md-8'], ['finder_city', 'col-lg-4 col-md-4']],
                        [['finder_country_code', 'col-lg-12 col-md-12']],
                    ],
                    default: [
                        [['finder_house_number', 'col-lg-4 col-md-4'], ['finder_house_name', 'col-lg-8 col-md-8']],
                        [['finder_street_line_1', 'col-lg-12 col-md-12']],
                        [['finder_city', 'col-lg-12 col-md-12']],
                        [['finder_county_code', 'col-lg-12 col-md-12']],
                        [['finder_country_code', 'col-lg-12 col-md-12']],
                        [['finder_zip_code', 'col-lg-12 col-md-12']],
                    ]
                },
                country_need_bank_validation: ['826', '616', '752', '372'],
            }
        },
        metaInfo () {
            return {
                title: this.lang('business_details')
            }
        },
        beforeRouteEnter(to, from, next) {
            let vm=this;
            next(vm => {
                // if (from.path == vm.quote_root_path +'business/pricing/') {
                //     vm.setMerchantRegistrationAddressFromQuote();
                // }

                let is_edit_url_and_not_masked_url = vm.$route.path.includes('/application/edit') && !vm.$route.path.includes('business_details_mask');
                if (!vm.isOpenApplication){
                    vm.$router.push({ path: `/application/view/${vm.$route.params.application_reference}/business_details/`})
                }
                else if (vm.isPiiDataMaskedBank && is_edit_url_and_not_masked_url) {
                    vm.$router.push({path: `/application/edit/${vm.$route.params.application_reference}/business_details/business_details_mask/`});
                }
                //reset validation in case user jumps back from review page after editing
                vm.resetValidation()
            })
        },
        beforeRouteLeave(to, from, next) {
            // if(this.abortRouteLeave){
            //     next();
            //     return; //prevent it from doing anything else
            // }

            // Avoid save when UI is masked
            if (this.isPiiDataMaskedBank) {
                next(true);
                return;
            }
            if(!this.checkDestinationRoute(to, from)){ //if user is going backwards, don't validate
                if (this.pageHasData() && !this.disable_go_back_warning_modal) {
                    this.alertBackRouteWarning((doCall = true) => next(doCall))
                } else {
                    next()
                    return;
                }
            }else{
               if (!this.isOpenApplication){
                   next(true);
               } else {
                   if (to.fullPath.includes('edit')) {
                       // If open application do validate and save
                       this.saveBusinessDetails(() => {next()});
                   } else {
                       next(true)
                   }
               }
            }
        },
        mounted() {
            this.pageConfig = this.page_config[this.page_config_template];
            let vm = this;
            const $store = useModuleStore();
            $store.commit(types.TOGGLE_LOADING, true);
            setTimeout(function () {
              if(vm.hasTenantAppDefaults) {
                vm.setApplicationDefaults(vm.merchant, 'BUSINESS', vm.parameters.TENANT_APP_DEFAULTS_PARAM)
                vm.setApplicationDefaults(vm.outlet, 'MAIN_OUTLET', vm.parameters.TENANT_APP_DEFAULTS_PARAM)

                vm.outlet.banks.forEach(bank => {
                  let bank_type = bank.account_type.toLowerCase();
                  vm.setBankDefaults(bank, bank_type, 'MAIN_OUTLET', vm.parameters.TENANT_APP_DEFAULTS_PARAM)

                    if (bank.account_type === 'DEBIT'){ //hold the initial value of the deposit bank faster payments value
                        vm.deposit_bank_faster_payments = bank.faster_payments
                    }
                    vm.fasterPaymentsAllowedForBank(bank, !!bank.bank_name ? bank.bank_name.toUpperCase() : null);
                })
              }
                vm.runPageConfig(vm.page_config[vm.page_config_template]);
                useModuleStore().commit(types.TOGGLE_LOADING, false);
                $("#form").formValidator({
                    // triggerElement: '', //trigger element default $('form').find('button[type="submit"]')
                    triggerEvent: '', // event - default 'click'
                    defaultConfig: '', // {} - object to set different configuration in validate.js
                    scrollToError: '', // enable auto-scroll to invalid element default true expect boolean
                    additionalCallbackFunction: '',
                });
            }, 1000);

            //seems to have a loading issue when left on created.
            this.country_code_params = this.getCountryCodeParams(this.app_default_param.ENTITY_BLOCK_BUSINESS, this.app_default_param.COUNTRY_CODE);
            this.setMerchantBank();

            if (!vm.canHaveIntermediaryByIso3(vm.getIso3FromCountryCode(vm.baseCountryCode), vm.merchant.ownership_entity_type)) {
                vm.resetIntermediaryBlock();
            }
            //this.omitBankTypesByCountryConfig();
        },
        created() {
        },
        computed: {
            // regNumberLabel: function(){
            //     if(this.allianceCountry == '616'){
            //         return this.lang('regon_reg_number')
            //     }
            //     return this.lang('company_registration_number');
            // },
            outlet: function () {
                return this.outlets[0];
            },
            outlet_bank: function () {
                return this.objectIsNotEmpty(this.outlet.banks[0]) ? this.outlet.banks[0] : new BankDetails();
            },
            principalOwnershipSum: function() {
                let total = 0

                if( !!this.merchant.owners && this.merchant.owners.length > 0 )
                {
                    this.merchant.owners.map(owner => {
                        total += parseInt( owner.ownership_perc )
                    })
                }

                //console.log('principal ownership', total)
                return total
            },
            ownershipBalance: function() {
                //New logic: separates PrincipalOwnership from intermediary Ownership percentage
                return 100;

                // let bal = 100
                // if( (100 - this.principalOwnershipSum ) >= 0 )
                //     bal = (100 - this.principalOwnershipSum )
                //
                // //console.log('ownership balance', bal)
                // return bal
            },
            dateOfIncorporationLabel: function () {
                let for_first_trading_date = [this.business_types.SOLE_TRADER, this.business_types.PARTNERSHIP]
                if ( for_first_trading_date.find(type => type === this.merchant.ownership_entity_type)) {
                    return this.lang('first_trading_date');
                } else {
                    return this.lang('date_incorporation');
                }
            },
            residualAccountTypes: function () {
                let vm = this
                return this.TYPE_OF_BANK_PARAM.filter(function (account_type) {
                    return !vm.outlet.banks.map(bank => { return bank.account_type }).includes( account_type.id ) && vm.bankTypeAllowedForTenant(account_type.id)
                })
                return [];
            },
            residualBankTypeParam: function () {
                let vm = this
                let hyper_list = []
                this.outlet.banks.map(function (current_bank, counter, bank) {
                    let selected_account_type = vm.TYPE_OF_BANK_PARAM.find(acc_type => { return acc_type.id === current_bank.account_type })
                    hyper_list[counter] = []
                    Object.assign( hyper_list[counter], vm.residualAccountTypes )
                    hyper_list[counter].push(selected_account_type)
                })

                return hyper_list
            },
            allianceCountry: function() {
                return defaultCountry;
            },
            bicIsOn: function(){
                //TODO find a better way to detect BIC aka swift was set or not
                let config_page = null
                if(this.parameters && this.parameters.hasOwnProperty('PAGE_CONFIGURATION_COMBINATION'))
                {
                    Object.entries(this.parameters.PAGE_CONFIGURATION_COMBINATION).map((payload, key) => {
                        payload.map((config, index) =>{
                            if(index === 1){
                                config_page = config && config.hasOwnProperty('SelfBusinessInformation')? config.SelfBusinessInformation : null
                            }
                        })
                    })
                }
                else if(this.pageConfig && this.pageConfig.hasOwnProperty('blocks') && this.pageConfig.blocks.hasOwnProperty('block_bank_accounts')) {
                    config_page = this.pageConfig
                }
                //console.log(config_page, this.pageConfig)
                let bank_config = config_page && config_page.hasOwnProperty('blocks') && config_page.blocks.hasOwnProperty('block_bank_accounts') ? config_page.blocks.block_bank_accounts : null;
                if(bank_config)
                {
                    let swift_element = bank_config.hasOwnProperty('elements') && bank_config.elements.hasOwnProperty('swift') ? bank_config.elements.swift : null
                    //console.log('bank_config', bank_config, swift_element)
                    if(swift_element){
                        //console.log('inzone')
                        return (swift_element.attribute.selected === 'Y')
                    }
                }

                return false
            },
            getVATValidationRules: function () {
                // if it is SWEDEN alliance, enforce numeric only validation
                if (this.allianceCountry == '752') {
                  return ['numeric'];
                }
                return ['alpha_numeric'];
            },
        },
        methods: {
            updateBankIsValidStatus: function(bank) {
                // bank.is_valid = '1'; //using '' to pass backend API when we "save"
                let no_account_number_validate_countries = ['SWE'];
                if (no_account_number_validate_countries.includes(this.getIso3FromCountryCode(this.baseCountryCode))) {
                    bank.is_valid = '1'; //means already validated
                } else {
                    bank.is_valid = '0';
                }
            },
            getBusinessAddressFinderStructureByIso3: function (iso3) {
                if (this.business_address_finder_structure.hasOwnProperty(iso3)) {
                    return this.business_address_finder_structure[iso3];
                } else {
                    return this.business_address_finder_structure.default;
                }
            },
            isFirstDepositBank(parsed_bank, index){
                if(parsed_bank.account_type === 'DEBIT') {
                    let response = true
                    this.outlet.banks.map(function (current_bank, counter, bank) { //(id, bank)

                        if (current_bank.account_type === 'DEBIT' && counter < index)
                            response = false
                    })
                    return response
                }
                else
                {
                    return false
                }
            },
            goBack: function (){
                this.abortRouteLeave = true;
                this.$router.push({path:  this.quote_root_path +'business/pricing/'})
            },
            doContinue: function () {
                let vm = this;
                //As per CR requirement we must validate IBAN before proceeding if it has value and if mandatory
                const validate_iban = vm.validateIban();
                if (validate_iban) {
                  let path_to = this.application_root_path + 'business_details/trading/';
                  vm.$router.push({path: path_to})
                }
            },
            pageHasData: function (){
                return this.formHasValues($('#form'))
            },
            addBank: function () {
              let vm = this;
                let need_bank_validation = vm.country_need_bank_validation.includes(vm.baseCountryCode);

              let is_valid_bank = this.outlet.banks.every(bank => {return bank.is_valid === '1'});
              // const form_is_valid = this.validateForm(`#form`);
              const form_is_valid = this.validateForm(`#bank_detail_form`); //TODO not sure if we should validate the whole form
              if ((!need_bank_validation || is_valid_bank) && form_is_valid && vm.outlet.banks.length <= vm.MAX_NUMBER_OF_BANKS_ALLOWED) {
                  let first_settlement_method = 'GROSS';
                  if (vm.outlet.banks.length > 0 && vm.outlet.banks[0].hasOwnProperty('settlement_method')  && !!vm.outlet.banks[0].settlement_method){
                      first_settlement_method = vm.outlet.banks[0].settlement_method
                  }

                  this.outlet.banks.push(new BankDetails({settlement_method: first_settlement_method}));
              }
              if (need_bank_validation && !is_valid_bank) {
                this.notifyError(this.lang('validation_error'), this.lang('bank_details_are_invalid'))
              }

              // Re run bank validation
              this.resetValidation()
            },
            resetIntermediaryBlock: function () {
                this.merchant['has_intermediary_owner'] = '0';
                if (this.merchant.intermediary_owners) {
                    this.merchant.intermediary_owners.splice(0);
                }
                this.merchant['additional_intermediary_owners'] = '0';
            },
            setSettlementMethodForAllBanks: function ($event){
                this.outlet.banks.forEach(obj =>{
                          obj.settlement_method = $event
                })
            },
            resetValidation: function(){
                let vm = this
                // Re run bank validation
                setTimeout(function() {
                    vm.runPageConfig(vm.page_config[vm.page_config_template]);
                    $("#form").formValidator({
                        // triggerElement: '', //trigger element default $('form').find('button[type="submit"]')
                        triggerEvent: '', // event - default 'click'
                        defaultConfig: '', // {} - object to set different configuration in validate.js
                        scrollToError: '', // enable auto-scroll to invalid element default true expect boolean
                        additionalCallbackFunction: '',
                    });
                    //     objCommon.general_radios_and_checkboxes($('#merchant-principal'));
                    //     objCommon.general_radios_and_checkboxes_deleg($('#merchant-principal'));
                    //
                }, 1000);
            },
            removeBank: function (index) {
              this.outlet.banks.splice(index, 1);
              $('.addPopover').popover('dispose')
            },
            validateBusinessDetails: function () {
                let vm = this;
                const form_is_valid = this.validateForm('#form');
                let form = this.getFormData($('#form')), section = form.section;

                let need_bank_validation = vm.country_need_bank_validation.includes(vm.baseCountryCode);

                //validate address
                let is_valid_address = this.addressIsValid(this.merchant.registration_address);

                //validate bank
                // let is_valid_bank = this.outlet.banks[0].is_valid === '1';
                let is_valid_bank = this.outlet.banks.every(bank => {return bank.is_valid === '1'}) && this.outlet.banks.length <= vm.MAX_NUMBER_OF_BANKS_ALLOWED;

                let settlement_method = this.outlet.banks[0].settlement_method;
                let is_valid_settlement_method = this.outlet.banks.every(bank => {return bank.settlement_method === settlement_method});

                // Name check
                let strEmailArray = this.outlet.banks.map(own => {return `${vm.getBankType(own.account_type)}`});
                let findDuplicates = arr => arr.filter((item, index) => item !== '' && arr.indexOf(item) != index) //first check prevents error on two empty email fields

                let duplicate_accounts = [...new Set(findDuplicates(strEmailArray))]; // All duplicates

                if (duplicate_accounts.length > 0) {
                  this.notifyError(this.lang('validation_error'), `${this.lang('validate_duplicate_accounts')}: ${duplicate_accounts.join(', ')}`);
                }
              //TODO save for later when ELavon fix their API
                // validate  incorporation date one month or more
                // let is_valid_incorp_date = moment().diff(moment(this.merchant.date_incorporated, 'DD-MM-YYYY'), 'months') > 0;

                if (need_bank_validation && !is_valid_bank) {
                    this.notifyError(this.lang('validation_error'), this.lang('bank_details_are_invalid'))
                }

                if (!is_valid_settlement_method) {
                    this.setHasErrorClassOnField(['settlement_method_'])
                    this.notifyError(this.lang('validation_error'), this.lang('validation_settlement_method'))
                }

                if (!is_valid_address) {
                    if (this.countCharacters(this.merchant.registration_address.house_name) === 0 && this.countCharacters(this.merchant.registration_address.house_number) === 0) {
                        this.setHasErrorClassOnField(['house_name', 'house_number'])
                        this.notifyError(this.lang('validation_error'), this.lang('validation_house_name_number_is_required'))
                    }
                    this.notifyError(this.lang('validation_error'), this.lang('validation_postcode_search'));
                }

                let is_valid_iban = vm.validateIban();
                let invalid = (need_bank_validation && !is_valid_bank) || !is_valid_address ||
                    duplicate_accounts.length > 0 || !is_valid_settlement_method || !is_valid_iban;
                // if (!is_valid_incorp_date) {
                //     this.notifyError(this.lang('validation_error'), this.lang('validation_business_incorp_date'));
                // }
                if (invalid) {
                    return false;
                }

                return form_is_valid;
            },
            nextPage: function(to_path) {
                // this.$router.push({path: to_path});
            },
            setRegNumber: function ($event){
                let vm = this;
                if (!vm.canHaveIntermediaryByIso3(vm.getIso3FromCountryCode(vm.baseCountryCode), vm.merchant.ownership_entity_type)) {
                    vm.resetIntermediaryBlock();
                }

                if (!this.canApplicationShowRegNumber){
                    this.merchant.reg_number = '';
                }

                if (this.quote) {
                    this.quote['ownership_entity_type'] = this.merchant.ownership_entity_type;
                }
            },
            setVatOptions: function ($event) {
                if($event === '1'){
                    this.merchant.vat_applied_flag = '';
                    this.merchant.other_tax_decision = '';
                    this.merchant.other_tax_id = '';
                }else{
                  this.merchant.tax_id = '';
                }
            },
            removeIntermediaryOwner(index) {
                if (this.merchant.intermediary_owners && this.merchant.intermediary_owners.length > index) {
                    this.merchant.intermediary_owners.splice(index, 1);
                }
            },
            toggleIntermediaryOwners($event) {
                let vm = this;
                if ($event === '0') {
                    if (this.merchant.intermediary_owners) {
                        vm.merchant.intermediary_owners.splice(0);
                    }
                    vm.merchant['additional_intermediary_owners'] = '0';
                } else if ($event === '1') {
                    vm.merchant.intermediary_owners = [new IntermediaryOwner()];
                    vm.merchant['additional_intermediary_owners'] = '0';
                    setTimeout(function() {
                      vm.runPageConfig(vm.pageConfig);
                    }, 500);
                }
            },
            addMoreIntermediaryOwners() {
                let vm = this;
                vm.merchant.intermediary_owners.push(new IntermediaryOwner());
                setTimeout(function() {
                    vm.runPageConfig(vm.pageConfig);
                }, 500);
            },
            setOtherVatTypes: function ($event) {
                // if vat options is vat pending unset every sub option
                    this.merchant.tax_id = '';
                if ($event === 'VAT_PENDING') {
                    this.merchant.other_tax_decision = '';
                    this.merchant.other_tax_id = '';
                }
            },
            setMerchantBank: function (){
                if (this.objectIsNotEmpty(this.outlet.banks[0]) && this.outlet.banks[0].account_holder_name === '') {
                    this.outlet.banks[0].account_holder_name = this.merchant.legal_name
                }

                let bank_types = this.parameters['BANK_TYPE_PARAM'];

                // Check if merchant's CountryCode has DEBIT BANK activated for self boarding
                let debit_type = bank_types.find(type => {
                    return ( type.country_code === this.baseCountryCode && type.self_boarding === "1" && type.bank_type === "DEBIT")
                })

                if(debit_type)
                {
                    // Check if merchant already has a debit bank
                    let debit = this.outlet.banks.find(bank => {
                        return ( bank.account_type === 'DEBIT' )
                    })

                    if(!debit)
                    {
                        // Check if merchant has a bank with empty account type
                        let account = this.outlet.banks.find(bank => {
                            return ( bank.account_type === '' )
                        })

                        if(account)
                        {
                            // Update the empty account type to "DEBIT"
                            account.account_type = "DEBIT"
                        }else{
                            // Create a debit account type for the user

                            let cur_len = this.outlet.banks.length
                            this.outlet.banks.push( new BankDetails() )
                            this.outlet.banks[cur_len]['account_type'] = "DEBIT"
                            this.resetValidation()
                        }
                    }
                }
            },
            omitBankTypesByCountryConfig: function(){
                //ensure outlet.banks are allowed bankTypeAllowedForTenant(account_type)
                //TODO confirm requirements linked to ELV-2231
                return true
            },
            updateBankIsValidIbanStatus: function (bank, $event) {
              if (!!this.old_valid_iban_value && !!bank.account_type && this.old_valid_iban_value.hasOwnProperty(bank.account_type)
                  && this.old_valid_iban_value[bank.account_type] !== $event) {
                bank.is_valid = '';
              }
            },
            bankIsValid: function (bank, $event, country_code = '') {
                //set the is_valid to the bank object
                let vm = this, is_valid = !!$event && !!$event.is_valid ? $event.is_valid : '0';

                // if(country_code === 'SWE'){
                //     is_valid = '1'
                // }
                bank['is_valid'] = is_valid;
                //console.log($event)
                if (is_valid === '1') {
                    let iban = $event?.iban ?? null;
                    if (!!this.old_valid_iban_value && !!bank.account_type && !!iban && this.old_valid_iban_value.hasOwnProperty(bank.account_type)) {
                        this.old_valid_iban_value[bank.account_type] = iban;
                    }
                    if(bank.account_type === 'DEBIT'){
                        //check that bank name
                        vm.fasterPaymentsAllowedForBank(bank, !!$event.bank ? $event.bank.toUpperCase() : null);
                    }

                    if (!(bank.iban)) {
                        bank['bank_name'] = $event.bank;
                    }
                } else {
                    if (!!$event.explanation) {
                        vm.notifyError(vm.lang('invalid_bank'), $event.explanation);
                    }
                }
            },
            fasterPaymentsAllowedForBank(bank, bank_name){
                let vm = this;
                let banks_not_support_faster_payment = ['SANTANDER UK PLC'];
                if (!!bank_name) {
                    if (banks_not_support_faster_payment.includes(bank_name)) {
                        if(bank.faster_payments === '1'){
                            bank.show_disabled_faster_payments_message = true;
                        }
                        bank.faster_payments = '0'
                        bank.disabled_faster_payments = '1'
                    }else{
                        //if a person selects Santander and the switches to another bank without saving, the faster_payment flag is lost.
                        //so we use the deposit_bank_faster_payments flag which holds the initial value.
                        let fp_value = vm.deposit_bank_faster_payments !== '' ? vm.deposit_bank_faster_payments : bank.faster_payments
                        bank.faster_payments = fp_value
                        bank.disabled_faster_payments = '0'
                        bank.show_disabled_faster_payments_message = false
                    }
                }
            },
            appendXXX: function (bank) {
                // As per CR Requirement, when the string has reached length 8 and loosing focus should append XXX as suffix
                if (!!bank.swift && bank.swift.length === 8) {
                  bank.swift = bank.swift + 'XXX';
                }
            },
            validateIban: function () {
              //As per CR requirement we must validate IBAN before proceeding if it has value and if mandatory
                let valid = true, bank_errors = [];

                //check bank iban is validated
              this.outlet.banks.forEach(bank => {
                  if (bank.iban !== '') {
                    if (bank.is_valid !== '1') {
                      valid = false;
                      bank_errors.push(bank.account_type + ' ' + this.lang('iban_validate'));
                    }
                  }
                })

                if (bank_errors.length  > 0){
                  let errorMessages = '';
                  bank_errors.forEach((err, idx, bank_errors) => {
                    if (idx === bank_errors.length - 1){
                      errorMessages += err
                    } else {
                      errorMessages += err + '<br>';
                    }
                  });
                  if (!!errorMessages) {
                    this.notifyError(this.lang('validation_error'), errorMessages, 9000);
                  }
              }

              return valid;
            },
            saveBusinessDetails: function (callback = null){
                let vm = this;
                if (vm.validateBusinessDetails()){
                  let form = this.getFormData($('#form'));
                    let section = form.section;
                    let payload = {
                        ...form, ...{
                            application_external_id: this.merchant.application_external_id,
                            alliance_external_id: this.merchant.alliance_external_id,
                            banks: this.outlet.banks,
                            outlet_external_id: this.outlet.outlet_external_id,
                            government_owned_entity: this.merchant.government_owned_entity,
                            reg_number: this.merchant.reg_number,
                        }
                    };

                    payload.intermediary_owners = this.merchant.intermediary_owners;
                    payload.has_intermediary_owner = this.merchant.has_intermediary_owner;
                    payload.additional_intermediary_owners = this.merchant.additional_intermediary_owners;
                    payload.reg_number = this.merchant.reg_number;
                    payload.section = section
                    payload.marketing_opt_in = this.merchant.marketing_opt_in;

                    vm[types.SAVE_MERCHANT](payload).then(response => {
                        if (response && response.data && response.data.result === 'SUCCESS'){
                            vm.notifySuccess(vm.lang('business_details_updated_successfully'));
                            if (vm.is_reviewing) {
                              vm.$emit('close_review_section');
                            }

                            let {outlets, application} = response.data;

                            if(!!outlets && outlets.length > 0){

                                this.outlet.banks.forEach(bank => {
                                    if(bank.account_type === 'DEBIT'){ //update the deposit flag
                                        vm.deposit_bank_faster_payments = bank.faster_payments;
                                    }
                                    vm.fasterPaymentsAllowedForBank(bank, bank.bank_name.toUpperCase())
                                })
                                let {equipmentOffer, onlineOffer} = outlets[0];

                                if(!!equipmentOffer){
                                    EventBus.emit('outlet-equipment_offer-update', equipmentOffer)
                                }
                                if(!!onlineOffer){
                                    EventBus.emit('outlet-online_offer-update', onlineOffer)
                                }
                            }

                            //sync application data to quote if needed
                            if (application && vm.quote) {
                                let application_to_quote_intersect_fields = {
                                    'reg_number': 'reg_number',
                                    'tax_id': 'tax_id',
                                };
                                Object.keys(application_to_quote_intersect_fields).forEach(key => {
                                    if (!!application[key]) {
                                        vm.quote[application_to_quote_intersect_fields[key]] = application[key];
                                    }
                                });
                                vm.setQuoteRegistrationAddressFromMerchant();
                            }

                            if(!!callback){ //call back is the next function in nav guard
                                callback();
                            }
                        }
                        else {
                            console.log(response);
                        }

                    }).catch(error => {
                        console.log(error)
                    })

                }
            },
            setQuoteRegistrationAddressFromMerchant: function () {
                let vm = this;
                if (!(vm.merchant) || !(vm.merchant.registration_address)) {
                    console.log('Error! vm.merchant.registration_address is empty.');
                    return;
                }
                let mapAddressFields = {
                    'house_number': 'house_number',
                    'house_name': 'house_name',
                    'street_line_1': 'street_line_1',
                    'street_line_2': 'street_line_2',
                    'zip_code': 'zip_code',
                    'city': 'city',
                    'county_code': 'county_code',
                    'country_code': 'country_code',
                };
                Object.entries(mapAddressFields).forEach( ([quote_key, merchant_key]) => {
                    //application merchant data hold the registration address block is more reliable
                    if (vm.merchant.registration_address.hasOwnProperty(merchant_key)) {
                        vm.quote.registration_address[quote_key] = vm.merchant.registration_address[merchant_key];
                    }
                });
            },
            ibanCheckConfiguration: function(bank) {
                // UK, Norway and Germany will base on Page Config to determined IBAn is Mandatory or not,
                // rest of countries will always based on required flag
                return (!!bank.isGBPBank || !!bank.isNORBank || !!bank.isGERBank);
            },
            ibanRequired: function(bank) {
                return (bank.isPOLBank || bank.isIRLBank || bank.isSWEBank);
            },
            ibanShowValidateButton: function(bank) {
                return bank.is_valid !== '1';
            }
        }
    }
</script>

<style scoped>
  body#portal #marketing-help {
    line-height: 18px;
  }
</style>
